import * as React from 'react';

import { useIntl } from 'react-intl';

import ProfileLayout from 'src/features/profile/components/ProfileLayout';
import ProfilePasswordForm from 'src/features/profile/components/ProfilePasswordForm';
import { passwordMessages, profileMessages } from 'src/features/profile/utils/messages';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import { useTitleStore } from 'src/stores/useTitleStore';

const Password = () => {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(profileMessages.title));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <ProfileLayout>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(passwordMessages.passwordTitle)}</SectionBlockTitle>
                        <SectionBlockSubtitle>{formatMessage(passwordMessages.passwordSubtitle)}</SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className="flex-col">
                    <ProfilePasswordForm />
                </SectionBlockBody>
            </SectionBlock>
        </ProfileLayout>
    );
};

export default Password;
